import { render, staticRenderFns } from "./ApplianceItem.vue?vue&type=template&id=22e0b0be&"
import script from "./ApplianceItem.vue?vue&type=script&lang=js&"
export * from "./ApplianceItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports